/**
 * お客様に渡すリンク（チェックイン・事前受付）は予約番号（連絡コード）で作る（2026-10-12）。
 * 連番の予約 ID（?id=）は順に試すだけで他人の予約にたどり着けるため、ページ側も受け付けをやめた。
 * オリジンは店舗別（那覇=n-car.jp / 宮古=pit-rent.com）。予約番号が無ければ入力画面が出る素の URL。
 */
export function checkinUrl(origin: string, contactCode?: string | null): string {
  const base = `${String(origin).replace(/\/+$/, '')}/sys/checkin/`;
  const code = (contactCode || '').trim();
  return code ? `${base}?code=${encodeURIComponent(code)}` : base;
}

export function formUrl(origin: string, contactCode?: string | null): string {
  const base = `${String(origin).replace(/\/+$/, '')}/sys/form/`;
  const code = (contactCode || '').trim();
  return code ? `${base}?contact_code=${encodeURIComponent(code)}` : base;
}
